/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { types } from '../actions/device';
import { combineAPIReducers } from './api';

export default combineAPIReducers(types);




// WEBPACK FOOTER //
// ./src/redux/reducers/device.js